module.exports = __webpack_public_path__ + "img/HC1010-74.63bbecc9.jpg";